import {Typography } from '@mui/material';
import useAuth from 'hooks/useAuth';
import AuthWrapper from 'sections/auth/AuthWrapper';
import AuthLogin from 'sections/auth/auth-forms/AuthLogin';
import logoDark from "../../assets/images/logo-dark.svg";

// ================================|| LOGIN ||================================ //

const Login = () => {
  const { isLoggedIn } = useAuth();

  return (
    <AuthWrapper>
      {/* <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
            <Typography variant="h3">Login</Typography>
            <Typography
              component={Link}
              to={isLoggedIn ? '/auth/register' : '/register'}
              variant="body1"
              sx={{ textDecoration: 'none' }}
              color="primary"
            >
              Don&apos;t have an account?
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <AuthLogin isDemo={isLoggedIn} />
        </Grid>
      </Grid> */}
      <div className="brand-logo">
        <img
          src={logoDark}
          className="img-fluid dark-logo"
          alt=""
        />
         {/* <Typography variant="h4">Administrator</Typography> */}
      </div>
      <div className="login-info">
        <Typography variant="h1">Welcome back,</Typography>
        <Typography variant="body1">Administrator</Typography>
        <AuthLogin isDemo={isLoggedIn} />
        <Typography className="bottom-content" variant="body1">Your platform <span>for prosperity</span></Typography>
      </div>
    </AuthWrapper>
  );
};

export default Login;
